import { forwardRef } from 'react'
import { NavLink, NavLinkProps } from 'react-router'

type Props = NavLinkProps & { activeClassName: NavLinkProps['className'] }

export const CustomNavLink = forwardRef<HTMLAnchorElement, Props>(
  ({ activeClassName, ...props }, ref) => (
    <NavLink ref={ref} {...props} className={`${props.className} ${activeClassName}`} />
  )
)

CustomNavLink.displayName = 'CustomNavLink'
